import { render, staticRenderFns } from "./AppThirdScreen.vue?vue&type=template&id=868098f6&scoped=true"
import script from "./AppThirdScreen.vue?vue&type=script&lang=js"
export * from "./AppThirdScreen.vue?vue&type=script&lang=js"
import style0 from "./AppThirdScreen.vue?vue&type=style&index=0&id=868098f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868098f6",
  null
  
)

export default component.exports